import React from 'react';
import RenderRow from './ListPathFunction'
import '../List/ItemStyle.css'
import { connect } from 'react-redux';
import {selectNewIndex} from '../../redux'
import convertData from './DateFunction'

 class PathList extends React.Component{
    constructor(props){
      super(props);

      
      this.state = {stato: props.stato}
    }

    selectPath(index){
      this.setState(function(prevState) {
          let newStato = [false,false,false,false,false,false,false,false,false,false]
          newStato[index] = true
          return {stato: newStato};
      });
      this.props.selectIndex(index)
    }



    render(){
      const {data} = this.props  
      
      let itinerario = []
      let dataPartenza = ""
      try {
          dataPartenza =data.requestParameters.date
          itinerario = data.plan.itineraries 
 
      }catch{
      }


    
      return (
      
        <div className={"ContenitoreLista"} >
            
           {itinerario.map((item, index) => (
             
             <RenderRow realTime={this.props.realTime} item={item} dataPartenza={dataPartenza} index={index} key={index} mode={data.requestParameters.mode} stato={this.state.stato[index]}  callback={this.selectPath.bind(this)}/>
             
           ))}
          </div>
         
     );
    }

}

const mapStateToProps = state => {
  return {
    indexData: state.index
  }
}
const mapDispatchToProps = dispatch => {
  return {
    selectIndex: (index) => dispatch(selectNewIndex(index))
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(PathList)